module.exports = __webpack_public_path__ + "static/visite-virtuelle-matterport-0af370afc5345b919aced078f75b8bc5.jpg";